import { useEffect, useState } from 'react';

import config from 'config';
import { BUSINESS_UNITS, user } from 'core';
import { getAccessToken } from 'core/services/auth';
import { STATUS } from 'core/utilities';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

export const useUserRequest = (isSearch = false, isStargate = false) => {
  const isVDI = config.app.short === BUSINESS_UNITS.VDI;
  const dispatch = useDispatch();
  const [isCalled, setIsCalled] = useState(false);
  const userCurrent = user.hooks.useUser();
  const userRequestStatus = user.selectors.useUserSelector().status;
  const location = useLocation();
  const accessToken = getAccessToken();
  const isAuthenticated = Boolean(accessToken);
  const hasResellerId = Boolean(userCurrent.data.resellerId);
  const isUserDataLoaded = userRequestStatus === STATUS.SUCCESS;
  const shouldFetchUserData = !hasResellerId || !isUserDataLoaded;

  useEffect(() => {
    if (userRequestStatus !== STATUS.IDLE || isCalled || !isAuthenticated) {
      return;
    }

    const isDepartamentos = location.pathname === '/departamentos';

    const shouldRequest =
      (isSearch && !isDepartamentos) ||
      (isStargate && isDepartamentos) ||
      isVDI ||
      shouldFetchUserData;

    if (shouldRequest) {
      setIsCalled(true);
      dispatch(user.actions.userResaleIntention.request());
    }
  }, [isAuthenticated, isCalled, shouldFetchUserData, isStargate, isSearch, userRequestStatus]);

  return {
    isAuthenticated,
    hasResellerId,
    isUserDataLoaded,
    userRequestStatus,
  };
};
